import React, { useMemo, useState } from "react";
import { Calendar as CalendarIcon } from "lucide-react";
import { format } from "date-fns";
import { Calendar } from "../UIElements/Calendar";
import { Popover, PopoverContent, PopoverTrigger } from "../UIElements/Popover";

const PromotionTimeline = ({ start, end, onChangeStart, onChangeEnd }) => {
  const [isStartOpen, setIsStartOpen] = useState(false);
  const [isEndOpen, setIsEndOpen] = useState(false);

  const startDate = useMemo(() => {
    if (!start) {
      return undefined;
    }
    const parsed = new Date(`${start}T00:00:00`);
    if (Number.isNaN(parsed.getTime())) {
      return undefined;
    }
    return parsed;
  }, [start]);

  const endDate = useMemo(() => {
    if (!end) {
      return undefined;
    }
    const parsed = new Date(`${end}T00:00:00`);
    if (Number.isNaN(parsed.getTime())) {
      return undefined;
    }
    return parsed;
  }, [end]);

  const handleSelectStartDate = (date) => {
    if (!date) {
      return;
    }
    onChangeStart(format(date, "yyyy-MM-dd"));
    setIsStartOpen(false);
  };

  const handleSelectEndDate = (date) => {
    if (!date) {
      return;
    }
    onChangeEnd(format(date, "yyyy-MM-dd"));
    setIsEndOpen(false);
  };

  return (
    <div className="rounded-xl border border-gray-800 bg-gray-900 p-6">
      <h3 className="mb-4 text-sm font-semibold tracking-wider text-gray-300 uppercase">
        Timeline
      </h3>
      <div className="space-y-4">
        <div>
          <label className="mb-1 block text-xs text-gray-400">Start Date</label>
          <Popover open={isStartOpen} onOpenChange={setIsStartOpen}>
            <PopoverTrigger asChild>
              <button
                type="button"
                className="relative w-full cursor-pointer rounded-lg border border-gray-800 bg-gray-950 py-2 pr-3 pl-10 text-left text-sm text-white outline-none focus:ring-1 focus:ring-blue-500"
                aria-label="Select start date"
              >
                <span className="block truncate">{start || "Select date"}</span>
                <CalendarIcon
                  size={14}
                  className="absolute top-1/2 left-3 -translate-y-1/2 text-gray-500"
                />
              </button>
            </PopoverTrigger>
            <PopoverContent
              align="start"
              className="w-auto border border-gray-800 bg-gray-900 p-0"
            >
              <Calendar
                mode="single"
                selected={startDate}
                onSelect={handleSelectStartDate}
                defaultMonth={startDate}
                initialFocus
              />
            </PopoverContent>
          </Popover>
        </div>
        <div>
          <label className="mb-1 block text-xs text-gray-400">End Date</label>
          <Popover open={isEndOpen} onOpenChange={setIsEndOpen}>
            <PopoverTrigger asChild>
              <button
                type="button"
                className="relative w-full cursor-pointer rounded-lg border border-gray-800 bg-gray-950 py-2 pr-3 pl-10 text-left text-sm text-white outline-none focus:ring-1 focus:ring-blue-500"
                aria-label="Select end date"
              >
                <span className="block truncate">{end || "Select date"}</span>
                <CalendarIcon
                  size={14}
                  className="absolute top-1/2 left-3 -translate-y-1/2 text-gray-500"
                />
              </button>
            </PopoverTrigger>
            <PopoverContent
              align="start"
              className="w-auto border border-gray-800 bg-gray-900 p-0"
            >
              <Calendar
                mode="single"
                selected={endDate}
                onSelect={handleSelectEndDate}
                defaultMonth={endDate}
                initialFocus
              />
            </PopoverContent>
          </Popover>
        </div>
      </div>
    </div>
  );
};

export default PromotionTimeline;
